<template>
    <div>
        <v-card>
            <v-toolbar
                flat
                color="primary"
                dark
                dense
            >
                <v-icon left>mdi-newspaper</v-icon>
                News
                <v-spacer />
                <v-btn
                    round
                    color="success"
                    :to="{name: 'OrgSelectedNews', params: {id: 'new'}}"
                >
                    <v-icon left>add</v-icon>
                    New Article
                </v-btn>
                <!--  -->
            </v-toolbar>
            <v-card-text>
                <v-layout
                    row
                    wrap
                >
                    <v-flex
                        sm3
                        style="display: flex;flex-direction: column;"
                    >
                        <v-text-field
                            v-model="search"
                            box
                            hide-details
                            :loading="loading"
                            label="Search Articles"
                            clearable
                            style="flex-grow: 0;"
                        />
                        <v-list
                            three-line
                            style="background: rgba(0,0,0,.03);border-radius: 5px;flex-grow: 1;"
                        >
                            <v-list-tile
                                v-for="na in newsarticles"
                                :key="na.id"
                                :class="{ 'primary--text': $route.params.id == na.id }"
                                @click="oepnArticle(na.id)"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="na.title"></v-list-tile-title>
                                    <v-list-tile-sub-title
                                        v-if="na.casetype"
                                        v-html="truncatedBody(na.casetype.name)"
                                        style="font-weight: bold;"
                                    />
                                    <v-list-tile-sub-title v-html="truncatedBody(na.body)"></v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn
                                :disabled="!canPrev"
                                icon
                                @click="goPage(-1)"
                            >
                                <
                            </v-btn>
                            &nbsp;
                            {{page * 10 - 9}}
                            -
                            {{page * 10 > total ? total : page * 10}}
                             of 
                            {{total}}
                            &nbsp;
                            <v-btn
                                :disabled="!canNext"
                                icon
                                @click="goPage(1)"
                            >
                                >
                            </v-btn>
                            <v-spacer />
                        </v-card-actions>
                    </v-flex>
                    <v-flex
                        sm9
                    >
                        <v-card
                            v-if="$route.params.id"  
                            style="margin: 0 10px 0 10px;"
                        >
                            <NewsEditor
                                :article.sync="$route.params.id"
                                @changed="changed = $event"
                                @cancel="$router.replace({name: 'OrgNews'})"
                                @fetch="getNewsarticles(this.search)"
                                @focus="$router.replace({name: 'OrgSelectedNews', params: {id: $event}});getNewsarticles(this.search)"
                            />
                        </v-card>
                      <div
                        v-else
                        style="display:flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;min-height: 600px;width: 100%;margin:auto;"
                      >
                        <div
                          style="text-align:center;font-size: 20px;font-weight: 300;"
                        >
                          <b>Select an article to manage, or create a new article to begin.</b><br />
                          <small>This page shows all news articles across your organization.<br />To manage specific cases, navigate to the "Cases" tab and select "Manage News"</small>
                        </div>
                        <div
                          style="display: flex;padding: 10px;background: #ECEFF1;border-radius: 10px;border: 1px solid #78909C;margin-top: 25px;opacity:0.7;max-width:500px;margin: 20px;"
                        >
                          <v-icon
                            left
                            size="32"
                            style="align-self: flex-start;"
                          >
                            mdi-information
                          </v-icon>
                          <div>
                            <div
                              style="font-size: 16px;font-weight: 700;"
                            >
                              About News Articles
                            </div>
                            <div
                              style="font-size: 12px;"
                            >
                              News Articles allow you to create posts that are accessible to all users, or only logged in users. Articles can also be used outside of CaseLocker with our API.<br /><br />
                              Articles may contain text, video links, and files.
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import api from '@/api'
import GlobalConstants from '@/globals'
import NewsEditor from '@/components/admin/NewsEditor'
import { mapActions } from 'vuex'

export default {
    components: {
        NewsEditor,
    },
    data () {
        return {
            newsarticles: null,
            changed: false,
            loading: false,
            loadingNa: false,
            saving: false,
            search: null,
            page: 1,
            canNext: false,
            canPrev: false,
            total: 0,
            ignoreNext: false
        }
    },
    created () {
        this.getNewsarticles()
        this.documentTitle('News Articles')
    },
    methods: {
        oepnArticle(id) {
            this.$router.push({name: 'OrgSelectedNews', params: {id: id}})
            this.changed = false
        },
        truncatedBody (html) {
            const plainText = html.replace(/<\/?[^>]+(>|$)/g, "");
            if (plainText.length <= 50) {
                return plainText;
            }
            let truncatedText = plainText.substring(0, 50);
            truncatedText = truncatedText.substring(0, truncatedText.lastIndexOf(" "));
            return truncatedText + "..."
        },
        goPage (int) {
            if (int < 0 && this.canPrev || int > 0 && this.canNext) {
                this.page = this.page + int
                this.getNewsarticles(this.search)
            }
        },
        getNewsarticles (named = null) {
            this.loading = true
            api.news.allnews.list({
                pageNum: this.page, count: 10, ordering: '-created_at', search: this.search
            })
                .then((data) => {
                    this.total = data['count']
                    this.canNext = data['next_page'] !== null
                    this.canPrev = data['previous_page'] !== null
                    this.newsarticles = data['results']
                    this.loading = false
                })
        },
    },
    async beforeRouteUpdate(to, from, next) {
        if (this.changed) {
            const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
            if (!answer)
                return false
        }
        next()
    },
    beforeRouteLeave (to, from, next) {
        if (this.changed) {
            const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
            if (!answer)
                return false
        }
        next()
    },
    watch: {
        search () {
            this.page = 1
            this.getNewsarticles(this.search)
        },
        focusNewsarticle: {
            handler(newValue, oldValue) {
                if (!this.$route.params.id || oldValue == null) {
                    this.changed = false
                }
            },
            deep: true,
            flush: 'post'
        }
    }
}
</script>

<style>

</style>